import {HttpClient, HttpHandler} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {environment} from '../../../environments/environment';
import {Observable} from 'rxjs';

@Injectable()
export class OttVoucherApi extends HttpClient {
  private baseUrl = environment.production ? '/ott-voucher' : environment.baseUrlCallback+'/ott-voucher';

  public constructor(handler: HttpHandler) {
    super(handler);
  }

  public initiateVoucherTransaction(voucherNumber: string, mobileNumber: string, sessionToken: string): Observable<any> {
    const url = this.baseUrl + '/initiate' + '?voucherNumber=' + voucherNumber + '&mobileNumber=' + mobileNumber + '&sessionToken=' + sessionToken;
    return super.post(url, '');
  }

  public redeemVoucher(voucherNumber: string, mobileNumber: string, sessionToken: string, transactionId): Observable<any> {
    const url = this.baseUrl + '/redeem' + '?voucherNumber=' + voucherNumber + '&mobileNumber=' + mobileNumber + '&sessionToken=' + sessionToken + '&transactionId=' + transactionId;
    return super.post(url, '');
  }
}
